import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { IoMdArrowForward } from 'react-icons/io';
import { FiTrash2 } from 'react-icons/fi'
import CartItem from '../components/CartItem'
import MercadoPagoButton from './MercadoPagoButton/MercadoPagoButton'
import { useDispatch, useSelector } from 'react-redux'
import { changeSideBar, clearCart } from '../action';

function SideBar() {
    const isOpen = useSelector(state => state.isOpen)
    const cart = useSelector(state => state.cart)
    const dispatch = useDispatch()
    const [total, setTotal] = useState(0)
    const [isCheckoutOpen, setIsCheckoutOpen] = useState(false)
    const [selectedPayment, setSelectedPayment] = useState('transfer')
    const getCurrency = (item) => item.currency || 'ARS'
    const cartCurrencies = Array.from(new Set(cart.map(getCurrency)))
    const isMixedCurrency = cartCurrencies.length > 1
    const totalCurrency = cartCurrencies[0] || 'ARS'

    const handleSideBar = () => {
        dispatch(changeSideBar())
    }
    const clearCarrito = () => {
        dispatch(clearCart())
    }

    const handleFinalize = () => {
        if (cart.length === 0) {
            alert("El carrito está vacío");
            return;
        }

        setIsCheckoutOpen((prev) => !prev)
    }

    useEffect(() => {
        const totalF = cart.reduce((accumulator, currentItem) => {
            return accumulator + Number(currentItem.price) * currentItem.quantity;
        }, 0)
        setTotal(totalF)
    }, [cart])

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }

        return () => {
            document.body.style.overflow = ''
        }
    }, [isOpen])

    const handleWhatsApp = () => {
        if (cart.length === 0) {
            alert("El carrito está vacío");
            return;
        }

        // Validar stock antes de enviar
        for (let item of cart) {
            if (item.quantity > item.stock) {
                alert(`La cantidad del producto "${item.title}" excede el stock disponible (${item.stock}).`);
                return;
            }
        }

        let message = " *Pedido desde la tienda web:*\n\n";

        cart.forEach(item => {
            message += `• ${item.title}\n`;
            message += `   - Cantidad: ${item.quantity}\n`;
            message += `   - Precio unitario: $${item.price}\n`;
        });

        message += `*Total del pedido:* $${total.toLocaleString('es-AR')}\n`;

        const phoneNumber = "5493425778808";

        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    }

    const cartSummary = useMemo(() => {
        return {
            title: 'Pedido Ecommerce Vintage',
            price: Number(total.toFixed(2)),
            currency: totalCurrency,
            quantity: 1,
            items: cart.map((item) => ({
                id: item.id,
                title: item.title,
                price: item.price,
                quantity: item.quantity,
                currency: item.currency || totalCurrency,
                description: item.description,
                pictureUrl: item.imageUrls && item.imageUrls.length > 0
                    ? item.imageUrls[0]
                    : item.imageUrl
            }))
        }
    }, [cart, total, totalCurrency])


    return (
        <>
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
                    onClick={handleSideBar}
                />
            )}
            <div className={`${isOpen ? 'right-0' : '-right-full'} fixed top-0 h-full w-full sm:w-[85vw] md:w-[35vw] max-w-full bg-white shadow-2xl transition-all duration-300 z-50 px-4 sm:px-6 lg:px-[35px] flex flex-col overflow-x-hidden`}>
                <div className='flex items-center justify-between py-4 sm:py-6 border-b border-slate-200'>
                    <div className='uppercase text-sm font-semibold text-slate-800'>Carrito ({cart.length})</div>
                    <div onClick={handleSideBar} className='cursor-pointer w-9 h-9 flex justify-center items-center rounded-full border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-300 transition'>
                        <IoMdArrowForward className='text-2xl' />
                    </div>
                </div>
                <div className='flex flex-col gap-y-2 flex-1 min-h-0 overflow-y-auto overflow-x-hidden border-b border-slate-200 py-2'>
                    {cart.map((item) => {
                        return <CartItem item={item} key={item.id} />
                    })}
                </div>
                <div className='flex flex-col gap-y-3 pt-4 pb-5 sm:pb-6 mt-auto sticky bottom-0 bg-white'>
                    <div className='flex w-full justify-between items-center'>
                        <div className='uppercase font-semibold text-slate-800 flex flex-col'>
                                <span className='mr-2'>Total:</span>
                                {isMixedCurrency ? (
                                    <span className="text-xs text-slate-500">Moneda mixta</span>
                                ) : (
                                    <>
                                        <span className="price-old">{totalCurrency === 'USD' ? 'US$' : '$'} {Number(total * 2).toLocaleString('es-AR')}</span>
                                        <span>{totalCurrency === 'USD' ? 'US$' : '$'} {total.toLocaleString('es-AR')}</span>
                                        <span className="text-[10px] text-slate-500">{totalCurrency}</span>
                                    </>
                                )}
                            </div>
                        <div onClick={clearCarrito} className='cursor-pointer bg-red-500 text-white w-12 h-12 flex justify-center items-center text-xl rounded-lg hover:bg-red-600 transition'>
                            <FiTrash2 />
                        </div>
                    </div>
                    <Link to={'/'} className='vintage-filter-btn flex py-3 justify-center items-center w-full font-medium text-center whitespace-normal leading-snug'>
                        Ver carrito
                    </Link>
                    <button
                        onClick={handleFinalize}
                        className='btn-vintage flex py-3 justify-center items-center w-full font-medium text-center whitespace-normal leading-snug'
                    >
                        Finalizar compra
                    </button>
                    {isCheckoutOpen && (
                        <div className='border border-slate-200 rounded-lg p-3 bg-slate-50 flex flex-col gap-3'>
                            <div className='text-sm font-semibold text-slate-800'>Elegi el medio de pago</div>
                            <label className='flex items-center gap-2 text-sm text-slate-700'>
                                <input
                                    type='radio'
                                    name='payment-method'
                                    value='transfer'
                                    checked={selectedPayment === 'transfer'}
                                    onChange={() => setSelectedPayment('transfer')}
                                />
                                Transferencia (WhatsApp)
                            </label>
                            <label className='flex items-center gap-2 text-sm text-slate-700'>
                                <input
                                    type='radio'
                                    name='payment-method'
                                    value='mercadopago'
                                    checked={selectedPayment === 'mercadopago'}
                                    onChange={() => setSelectedPayment('mercadopago')}
                                />
                                Mercado Pago
                            </label>
                            <label className='flex items-center gap-2 text-sm text-slate-700'>
                                <input
                                    type='radio'
                                    name='payment-method'
                                    value='card'
                                    checked={selectedPayment === 'card'}
                                    onChange={() => setSelectedPayment('card')}
                                />
                                Tarjeta
                            </label>

                            {selectedPayment === 'transfer' ? (
                                <button
                                    onClick={handleWhatsApp}
                                    className='btn-vintage flex py-3 justify-center items-center w-full font-medium text-center whitespace-normal leading-snug'
                                >
                                    Enviar Pedido por WhatsApp
                                </button>
                            ) : (
                                <div className='flex flex-col gap-2'>
                                    {isMixedCurrency ? (
                                        <div className='text-xs text-slate-600'>
                                            El pago online no esta disponible con moneda mixta.
                                        </div>
                                    ) : (
                                        <MercadoPagoButton
                                            product={cartSummary}
                                            label={selectedPayment === 'card' ? 'Pagar con tarjeta' : 'Pagar con Mercado Pago'}
                                            className='btn-vintage flex py-3 justify-center items-center w-full font-medium text-center whitespace-normal leading-snug'
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default SideBar
